import MultisigTxInfoModal from './MultisigTxInfoModal'

export default MultisigTxInfoModal
